import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Prototype: no real auth
  };
  return <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 pt-16" data-id="element-2394" data-mp="33ebq6uj8fy9t">
      {/* Form side */}
      <div className="flex items-center justify-center px-6 py-16" data-id="element-2395" data-mp="38cvday9kbg3r">
        <div className="w-full max-w-sm" data-id="element-2396" data-mp="38f7rr1g438c2">
          <div className="flex items-center mb-8" data-id="element-2397" data-mp="2tos7ppzfm6fh">
            <img src="https://cdn.magicpatterns.com/uploads/gbY7Dn8gGgHtYDAdDbncPd/zano_logo_full1.png" alt="Zano" className="h-8 w-auto" data-id="element-2398" data-mp="2tnyy8h9392tn" />
          </div>

          <h1 className="text-2xl font-bold text-zano-charcoal mb-2" data-id="element-2399" data-mp="3matgr8mchs4h">
            Welcome back
          </h1>
          <p className="text-gray-500 mb-8" data-id="element-2400" data-mp="2rh27izblmh77">Log in to your Zano workspace.</p>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-2401" data-mp="2rey5yo169ua3">
            <div data-id="element-2402" data-mp="2mj0o2da9gfv7">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-2403" data-mp="2mjiwe8a76kjh">
                Email
              </label>
              <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-zano-pink/40 focus:border-zano-pink" data-id="element-2404" data-mp="2wfdixehjkzrj" />
            </div>
            <div data-id="element-2405" data-mp="3f7eoezotno9x">
              <div className="flex items-center justify-between mb-1.5" data-id="element-2406" data-mp="3f4shn29r9csr">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-2407" data-mp="1ps8hq7d4q26m">
                  Password
                </label>
                <a href="#" className="text-xs font-medium text-zano-pink hover:underline" data-id="element-2408" data-mp="2aic6dxrloeyd">
                  Forgot password?
                </a>
              </div>
              <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-zano-pink/40 focus:border-zano-pink" data-id="element-2409" data-mp="2jjiqegtgk7wd" />
            </div>
            <Button variant="primary" type="submit" className="w-full justify-center py-2.5" data-id="element-2410" data-mp="3770ikdgmx7zv">
              Log in
            </Button>
          </form>

          <div className="flex items-center gap-3 my-6" data-id="element-2411" data-mp="3h4y6t0yhv4sh">
            <div className="h-px flex-1 bg-gray-200" data-id="element-2412" data-mp="3h5fz5mi1cyv4" />
            <span className="text-xs text-gray-400" data-id="element-2413" data-mp="15i4gvkigova2">or</span>
            <div className="h-px flex-1 bg-gray-200" data-id="element-2414" data-mp="15fhyepu18vd2" />
          </div>

          <Button variant="secondary" className="w-full justify-center py-2.5 !text-gray-700 !border-gray-300 hover:!bg-gray-50" data-id="element-2415" data-mp="10h6pchbkaovw">
            <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="" className="w-4 h-4 mr-2" data-id="element-2416" data-mp="qlded2dhr3g8" />
            Continue with Google
          </Button>

          <p className="text-center text-sm text-gray-500 mt-8" data-id="element-2417" data-mp="1jaanofzq5pwu">
            New to Zano?{' '}
            <Link to="/pricing" className="font-medium text-zano-pink hover:underline" data-id="element-2418" data-mp="1ehhgzmkp47i4">
              Request a demo
            </Link>
          </p>
        </div>
      </div>

      {/* Brand panel */}
      <div className="hidden lg:flex relative items-center justify-center bg-gradient-to-br from-zano-blush via-white to-zano-lavender overflow-hidden" data-id="element-2419" data-mp="270wte0m9ay3o">
        <div className="absolute top-10 right-10 w-72 h-72 bg-zano-pink/10 rounded-full blur-3xl" data-id="element-2420" data-mp="1mp2dd255pv4s" />
        <div className="relative z-10 max-w-md px-10" data-id="element-2421" data-mp="1rq8793ajzofw">
          <h2 className="text-3xl font-bold text-zano-charcoal mb-4 leading-tight" data-id="element-2422" data-mp="1crxp8wrr3plc">
            The Creator Asset OS for modern teams
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-2423" data-mp="1hrsg50bj0f6e">
            Source, license, and activate creator content from one connected
            workflow.
          </p>
          <div className="bg-white rounded-2xl border border-gray-100 shadow-float p-5" data-id="element-2424" data-mp="2afoj2mrov3bm">
            <div className="flex items-center gap-3 mb-4" data-id="element-2425" data-mp="1vqs4s7z1gu2k">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=80&q=80" alt="" className="w-11 h-11 rounded-full object-cover" data-id="element-2426" data-mp="1vq8yjoir3u4d" />
              <div data-id="element-2427" data-mp="2odmq173ojxh3">
                <p className="font-semibold text-gray-900 text-sm" data-id="element-2428" data-mp="2t6pj7e4jp4wr">
                  Elena Rodriguez
                </p>
                <p className="text-xs text-gray-500" data-id="element-2429" data-mp="hq5hvwznw4ue">
                  Select Mgmt • Live profile
                </p>
              </div>
            </div>
            <div className="space-y-2" data-id="element-2430" data-mp="cq9lojx7hhpe">
              {['Media kit up to date', 'Rights tracked', 'Brief generated'].map(t => <div key={t} className="flex items-center gap-2 text-sm text-gray-700" data-id="element-2431" data-mp="mk9sqrc1sx0r">
                  <CheckCircle2 size={15} className="text-green-500" data-id="element-2432" data-mp="3pznvidi6qyzb" /> {t}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
};